<template>
     <el-dialog
        :visible.sync="addPmtShow"
        title="新建打款记录"
        class="pmt-modal"
        destroy-on-close
        :show-close="false"
        width="460px"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        >
        <div>
            <Form ref="pmtForm" :model="pmtForm">
                <div class="pmt-form-Item">
                    <div class="label">客户名</div>
                    <Select v-model="pmtForm.publisher_id" filterable >
                        <Option v-for="item in cityList" :value="item.partner_id" :key="item.partner_id">{{ item.user_name }}({{item.email}})</Option>
                    </Select>
                </div>

                <div class="pmt-form-Item">
                    <div class="label">客户账号（邮箱）</div>
                    <Input v-model="pmtForm.email" placeholder="email" disabled></Input>
                </div>
                
                <div class="pmt-form-Item">
                    <div class="label">打款金额</div>
                    <el-input size="small" style="width:320px" placeholder="填写金额，最多两位小数" v-model="pmtForm.recharges" @input="pmtForm.recharges = pmtForm.recharges.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')" />

                </div>
                <div class="pmt-form-Item">
                    <div class="label">打款时间</div>
                    <Date-picker @on-change="recharge_time_fun" v-model="pmtForm.recharge_time" type="datetime" format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期和时间" style="width:320px" ></Date-picker>
                </div>
                <div class="pmt-form-Item">
                    <div class="label">货币方式</div>
                    <Input v-model="pmtForm.currency" placeholder="货币方式" disabled></Input>
                </div>
                <div class="pmt-form-Item">
                    <div class="label">打款类型</div>
                    <Select v-model="pmtForm.recharge_type" filterable >
                    
                        <Option v-for="item in rechargeList" :value="item.value" :key="item.value">{{item.name}}</Option>
                        <!-- <Option :value="2">赠送</Option> -->
                    </Select>
                </div>
                <!-- 图片上传 -->
                <div class="pmt-form-Item">
                    <div class="label">
                        <span>打款凭证</span>
                    </div>
                    <div class="banner-img-list">
                        <!-- 上传框 -->
                        <div class="banner-img-item">
                            <!-- 影子元素 -->
                            <input
                                ref="imgUrl"
                                type="file"
                                hidden
                                accept="image/jpeg,image/jpg,image/png"
                                @change="onFileChange($event)"
                            />
                            <!-- 上传中动画 -->
                            <div @click="$refs.imgUrl.click()" class="item-upload">
                                <Icon class="item-upload-icon" type="plus-round"></Icon>
                                <span class="item-upload-text">上传</span>
                            </div>
                        </div>
                        <!-- 缩略图框 -->
                        <div v-for="(item, index) in imgList" :key="index" class="banner-img-item img-item">
                            <img class="item-img" :src="item" />
                            <div class="img-function" @click="remove(index)">
                                <span class="function-icon"><Icon type="close"></Icon></span>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="" style="display:inline-flex;justify-content:center;width:100%;">
                    <Button type="primary" @click="asyncOK('1')">提交</Button>
                    <Button type="ghost" @click="asyncNo('0')" style="margin-left: 8px">取消</Button>
                </div>
            </Form>
        </div>
    </el-dialog>
</template>
    <script>
import cSpin from '@/components/commons/cSpin.vue';
import mixins from '@/mixins/index';
    export default {
        name: 'Advertisement',
        data(){
            return{
                state:'',
                cityList:[],
                loading: false,
                imgList:[],
                rechargeList:[{name:'充值',value:1},{name:'赠送',value:2}]
            }
        },
        mixins: [mixins],
        components: { cSpin },
        props:{
            addPmtShow:{
                default:true
            },
            pmtForm:{
              type: Object,
              default(){
                return{
                    publisher_id:'',//客户名
                    email:'',//邮箱
                    recharges:'',//金额
                    recharge_time:'',//时间
                    currency:"USD",
                    recharge_type:'',//类型
                    recharge_certify:'',//凭证
                }
              }
            },
        },

        watch:{
            'pmtForm.publisher_id':{
                    handler(newValue) {
                     let obj = this.cityList.find((e)=>{
                        return e.partner_id === newValue
                     })
                    console.log('obj',obj)
                    if(obj)this.pmtForm.email = obj.email ? obj.email :' '
                    },
                    deep:true
            },
            imgList:{
                handler(newValue){
                    console.log(newValue)
                    this.pmtForm.recharge_certify = newValue.join(',')
                    console.log('pmtForm',this.pmtForm.recharge_certify)
                }
            }
        },

        async mounted(){
            const res = await this.$axios.get(this.$port.pmt.userInfoList,{});
            console.log('res',res)
            this.cityList = res.data
        },
        methods: {
            ResetForm(){
                // this.pmtForm.email = ''
                this.imgList = []
            },
            //提交打款按钮
            asyncOK(state){
                console.log('pmtForm',this.pmtForm)
  
                let form = this.pmtForm
                for(let key in form){
                    console.log('this.pmtForm[key]',key,form[key])
                    if(form[key] == null || form[key] === ''){
                        console.log('this.pmtForm[key]',key,form[key])
                        alert('请完整填写打款记录')
                        return 
                    }
                }
                console.log('pmtForm',form)
                this.$emit('onBtn',state)
            },
            //取消打款按钮
            asyncNo(state){this.$emit('onBtn',state)},
            /**
             * @desc: 金额正则
             */
            rechargesReplace(e){
                e = String(e)
                console.log('.../=>',e)

                let filtered = e.replace(/[^\-?\d.]/g,'');  

                console.log('.../',filtered)

                this.pmtForm.recharges = filtered
            },
            
            getUserItem(item){
                console.log('item',item)
            },
            recharge_time_fun(){
                let d = new Date(this.pmtForm.recharge_time);
                let datetime = d.getFullYear() + '-' 
                + ((d.getMonth() + 1)>9?(d.getMonth() + 1):'0'+(d.getMonth() + 1)) + '-' 
                + (d.getDate()>9?d.getDate():'0'+d.getDate()) + ' ' 
                + (d.getHours() > 9 ? d.getHours():'0' + d.getHours() ) + ':' 
                + (d.getMinutes() > 9 ?d.getMinutes():'0'+d.getMinutes()) + ':' 
                + (d.getSeconds() > 9 ?d.getSeconds():'0'+d.getSeconds());
                console.log(this.pmtForm.recharge_time,datetime)
                this.pmtForm.recharge_time = datetime
            },  

            remove(index){
                this.imgList.splice(index,1)
            },

            /**
         * @desc 上传图片
         * @param {Event} e: 原生input事件
         */
        async onFileChange(e) {
            const files = Array.from(e.target.files);
            //没有选择图片则返回
            if (!files.length) return;

            // 尺寸限制200k
            // if (files.some((file) => file.size > 1024 * 500)) {
            //     this.$Message.error({ content: '请上传正确大小的图片', duration: 2 });
            //     return;
            // }

            const formData = new FormData();
            files.forEach((file) => formData.append('img', file));
            const res = await this.$axios.post(this.$port.manager.uploadImg + '?type=1', formData, { cancelLoading: true });

            //数据处理
            // const arr = [];
            // res.data.urls.forEach((url, index) => {
            //     this.arr.push({
            //         urls
            //         // imgUrl: url,
            //         // name: files[index].name.split('.')[0],
            //     });
            // });
            this.imgList.push(res.data.urls[0])

            e.target.value = '';
        },


        }
    };
    </script>

    <style lang="less" scoped>
     .pmt-modal /deep/ .ivu-modal-footer{
        display:none;
     }
     .pmt-form-Item{
        width:100%;
        display:inline-flex;
        justify-content:flex-start;
        margin-bottom:20px;
        .label{
         width:70px;
        }
        .ivu-input-wrapper,.ivu-select{
            width:320px;
        }
       /deep/ .el-input__inner{
            padding:0px 6px !important
        }
     }
     .banner-img-list{
        display:flex;
        flex-flow:row wrap;
        width:400px;
     }
     .banner-img-item{
        width:100px;
        height:100px;
        border:1px solid #ccc;
        margin-right:10px;
        margin-bottom:10px;
        .item-img{
            width:100px;
            height:100px;
        }
        .item-upload{
            width:99px;
            height:99px;
            display:inline-flex;
            flex-flow:column wrap;
            align-items:center;
            justify-content:center;
            cursor: pointer;
            .item-upload-icon{
                width:32px;
                font-size:40px;
            }
        }
     }
     .img-item{
        position: relative;
        .img-function{
            display:none;
            position:absolute;
            top:0;
            right:0;
            width:20px;
            height:20px;
            background:rgba(0,0,0,0.5);
            cursor: pointer;
        }
        &:hover{
            .img-function{
                display:flex;
                justify-content:center;
                .function-icon{
                    color:#fff;
                }
            }
        }
     }
    </style>


// WEBPACK FOOTER //
// src/view/Payment/AddPaymentRecord.vue